module.exports = __webpack_public_path__ + "static/media/RoadsideAssistance.94126729.png";